import React from 'react'
import { DatePicker as BaseDatePicker } from 'baseui/datepicker'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPage/getError'
import useBuildingPermit from './useBuildingPermit'

const DatePicker = BaseDatePicker as React.ComponentType<any>

const BuildingPermitFields = () => {
  const {
    t,
    errors,
    isEditable,
    buildingPermitNumber,
    buildingPermitDate,
    buildingPermitEntity,
    buildingPermitCity,
    hideBuildingPermitFields,
    updateAddress,
  } = useBuildingPermit()

  if (hideBuildingPermitFields) return null

  return (
    <>
      <SDFormControl error={getError('buildingPermitNumber', errors)}>
        <SDInput
          label={t('subscriptionForm:address_module.building_permit_fields.number')}
          disabled={isEditable === false}
          currentValue={buildingPermitNumber ?? ''}
          onBlur={(value: string | null) => updateAddress({ buildingPermitNumber: value ?? '' })}
          error={getError('buildingPermitNumber', errors)}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SDFormControl>

      <SDFormControl label={t('subscriptionForm:address_module.building_permit_fields.creation_date')}>
        <DatePicker
          placeholder='DD/MM/YYYY'
          clearable
          disabled={isEditable === false}
          value={buildingPermitDate}
          maxDate={new Date(Date.now())}
          formatString='dd/MM/yyyy'
          onChange={({ date }: { date: Date | Date[] | null }) => {
            if (!date) {
              updateAddress({ buildingPermitDate: null })
              return
            }
            const finalDate = new Date(date + ' UTC').toISOString().slice(0, 10)
            updateAddress({ buildingPermitDate: finalDate })
          }}
        />
      </SDFormControl>

      <SDFormControl error={getError('buildingPermitCity', errors)}>
        <SDInput
          label={t('subscriptionForm:address_module.building_permit_fields.issuing_city')}
          disabled={isEditable === false}
          currentValue={buildingPermitCity ?? ''}
          onBlur={(value: string | null) => updateAddress({ buildingPermitCity: value ?? '' })}
          error={getError('buildingPermitCity', errors)}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SDFormControl>

      <SDFormControl error={getError('buildingPermitEntity', errors)}>
        <SDInput
          label={t('subscriptionForm:address_module.building_permit_fields.issuing_entity')}
          disabled={isEditable === false}
          currentValue={buildingPermitEntity ?? ''}
          onBlur={(value: string | null) => updateAddress({ buildingPermitEntity: value ?? '' })}
          error={getError('buildingPermitEntity', errors)}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SDFormControl>
    </>
  )
}

export default BuildingPermitFields
